import React from 'react';
import { X } from 'lucide-react';
import {
  T05_LEGAL_STAND,
  T05LegalAgbBody,
  T05LegalImpressumBody,
  T05LegalPrivacyBody,
} from './t05LegalContent';

export type T05LegalModalId = 'agb' | 'privacy' | 'impressum' | null;

interface T05LegalModalsProps {
  active: T05LegalModalId;
  onClose: () => void;
}

/**
 * Volltext-Modals — kanonische Inhalte aus t05LegalContent (Orbis-Kanon / RECHTSTEXTE_KONSISTENZ).
 */
export const T05LegalModals: React.FC<T05LegalModalsProps> = ({ active, onClose }) => {
  if (!active) return null;

  const isWide = active === 'agb' || active === 'privacy';

  return (
    <div className="t05-modal-backdrop" role="dialog" aria-modal="true" onClick={onClose}>
      <div
        className={`t05-modal t05-modal--legal${isWide ? ' t05-modal--legal-wide' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="t05-nav__ghost t05-modal__close"
          onClick={onClose}
          aria-label="Schließen"
        >
          <X size={18} />
        </button>

        {active === 'impressum' && (
          <>
            <h3>Impressum &amp; Offenlegung</h3>
            <p className="t05-modal__lead">Gemäß § 25 Mediengesetz &amp; § 5 ECG</p>
            <T05LegalImpressumBody />
          </>
        )}

        {active === 'privacy' && (
          <>
            <h3>Datenschutzerklärung</h3>
            <p className="t05-modal__lead">Gemäß DSGVO</p>
            <T05LegalPrivacyBody />
          </>
        )}

        {active === 'agb' && (
          <>
            <h3>Allgemeine Geschäftsbedingungen</h3>
            <p className="t05-modal__lead">Stand: {T05_LEGAL_STAND}</p>
            <T05LegalAgbBody />
          </>
        )}
      </div>
    </div>
  );
};
